import { useAuthContext } from './agencyAuthHook'
import { getAllDefaultConfig } from '../redux/reducers/defaultConfigSlic'
import { useDispatch } from 'react-redux';

export default function DegfaultConfigHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { agency } = useAuthContext()
    const getDefaultConfigurations=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/agencies/configurations/get/default`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllDefaultConfig(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getDefaultConfigurations}
}
